import React from 'react';
import { formatNumber } from '../../../core/helpers/format-number';

import { TableCol4Model } from '../../../core/models/tables';

interface ILngArrivalsTable {
  data: TableCol4Model[];
}

export default function LngArrivalsTable({ data }: ILngArrivalsTable): JSX.Element {
  return (
    <div className="LngArrivalsTable">
      <h3>LNG Arrivals in North West Europe</h3>
      <div className="table-container">
        <table className="total-table total-table-stripped table-sm">
          <thead>
            <tr>
              <th>Terminal</th>
              <th>Regas Volume (mcm)</th>
              <th>
                Expected <br /> Arrival
              </th>
              <th>From</th>
            </tr>
          </thead>
          <tbody>
            {data.map((arrival, index) => (
              <tr key={index}>
                <td>{arrival.col1}</td>
                <td>{formatNumber(arrival.col2)}</td>
                <td>{arrival.col3}</td>
                <td>{arrival.col4}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
